import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl07 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_07",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "No_Sight",
			className: "black",
			d: "M53,8h-15c-1.65,0-3,1.35-3,3v15c0,1.65,1.35,3,3,3h15c1.65,0,3-1.35,3-3v-15c0-1.65-1.35-3-3-3ZM44.09,18.5l-2.43,2.43c-.98-.55-2.01-1.33-3.2-2.43,1.18-1.08,2.22-1.86,3.21-2.42l2.42,2.42ZM43.66,15.24c.6-.16,1.21-.24,1.83-.24.65.02,1.26.1,1.85.25l-1.84,1.84-1.84-1.84ZM45.5,19.91l1.84,1.84c-.6.16-1.2.24-1.82.24-.65-.02-1.27-.1-1.86-.25l1.84-1.84ZM46.91,18.5l2.43-2.43c.98.55,2.01,1.33,3.2,2.43-1.18,1.08-2.22,1.86-3.21,2.42l-2.42-2.42ZM50.8,14.62l3.2-3.2v5.72c-1.15-1.06-2.2-1.89-3.2-2.52ZM48.92,13.66c-1.09-.42-2.19-.63-3.4-.66h-.03c-1.19,0-2.3.21-3.43.66l-3.66-3.66h14.17l-3.66,3.66ZM40.2,14.62c-1,.63-2.06,1.46-3.2,2.52v-5.72l3.2,3.2ZM37,19.87c1.15,1.06,2.2,1.89,3.2,2.51l-3.2,3.2v-5.72ZM42.08,23.34c1.1.42,2.21.63,3.42.66,1.19,0,2.3-.21,3.43-.66l3.66,3.66h-14.17l3.66-3.66ZM50.8,22.38c1-.63,2.06-1.46,3.2-2.52v5.72l-3.2-3.2Z"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Train",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M28.21,46.75c-2.69,1.99-5.23,2.8-8.77,2.8s-6.08-.81-8.77-2.8l-1.19,1.61c3.02,2.24,6,3.2,9.96,3.2s6.93-.96,9.96-3.2l-1.19-1.61Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M30.79,34.04c-.35-4.85-4.99-10.04-11.33-10.04s-10.98,5.19-11.33,10.04c-.28,3.87-.24,9.61,1.52,14.98,1.62,4.92,3.33,6.97,9.81,6.97s8.19-2.06,9.81-6.97c1.77-5.37,1.8-11.11,1.52-14.98ZM27.37,48.4c-1.36,4.15-2.33,5.6-7.91,5.6s-6.55-1.45-7.91-5.6c-1.66-5.06-1.7-10.53-1.43-14.22.29-3.95,4.11-8.19,9.34-8.19s9.05,4.23,9.34,8.19c.27,3.69.23,9.15-1.43,14.22Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M26.21,34.02c-.32-3.36-4.41-4.25-6.77-4.25s-6.45.9-6.77,4.25c-.28,2.91.82,4.79,1.8,5.87,1.29,1.42,3.15,2.27,4.98,2.27s3.69-.85,4.98-2.27c.97-1.07,2.08-2.96,1.8-5.87ZM22.94,38.54c-.9.99-2.24,1.61-3.5,1.61s-2.59-.62-3.5-1.61c-.7-.77-1.49-2.15-1.29-4.33.23-2.42,4.74-2.44,4.78-2.44s4.55.03,4.78,2.44c.21,2.18-.58,3.56-1.29,4.33Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M14.66,46.81c-.44,0-.84-.29-.96-.73l-.66-2.34c-.15-.53.16-1.08.69-1.23.53-.15,1.08.16,1.23.69l.66,2.34c.15.53-.16,1.08-.69,1.23-.09.03-.18.04-.27.04Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M24.22,46.81c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.66-2.34c.15-.53.71-.84,1.23-.69.53.15.84.7.69,1.23l-.66,2.34c-.12.44-.53.73-.96.73Z"
				})
			]
		})]
	})]
});
export default SvgAppIcBefehl07;
